// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.data-form[data-v-662c2b78] {\n  max-height: 400px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  padding: 10px;\n}\n.data-row[data-v-662c2b78] {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
